export class ClosingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanClosingAmortizationSchedule({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/loan-closing/amortization-schedule`);
  }

  async editLoanClosingInfoByApplicationId({ applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/loan-closing`, body);
  }

  async editLoanClosingCompanyByApplicationId({ applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/loan-closing/attendant-company`, body);
  }

  async deleteLoanClosingCompanyByApplicationId({ applicationId, attendantCompanyId, ...params }) {
    return this.#http.delete(
      `/application/${applicationId}/loan-closing/attendant-company/${attendantCompanyId}`,
      { params },
    );
  }

  async getAttendantCompanies() {
    return this.#http.get('/attendant-companies');
  }
}
